import axios from './axios'

export function requestPasswordReset (credentials) {
  return axios.post('/password/email', credentials)
}

export function fetchUser (options) {
  return axios.get('/whoami')
}

export default {
  requestPasswordReset,
  fetchUser
}



// WEBPACK FOOTER //
// ./src/services/auth.js